import { Component, OnInit } from '@angular/core';
import { GoogleTagManagerService } from 'src/app/services/google-tag-manager.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-btn-sac',
  templateUrl: './btn-sac.component.html',
  styleUrls: ['./btn-sac.component.scss']
})
export class BtnSacComponent implements OnInit {

  textPhone: string | undefined;
  textBtnSac: string | undefined;
  sacUrl: string | undefined;

  constructor(private gtmService: GoogleTagManagerService,) { }

  ngOnInit(): void {
    this.sacUrl = environment.contacts.phone
    this.textPhone=environment.contacts.textPhoneSac
    this.textBtnSac=environment.contacts.textPhoneButtonSac
  }

  async onPhoneButtonClick() {
    this.gtmService.push({
      event: 'contactSac'
    });
  }

}
